module.exports = __webpack_public_path__ + "img/slide3.c3285efc.png";